var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLongevity = function SvgLongevity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#longevity_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "m6 12-.697-.635a78 78 0 0 1-2.597-2.483Q1.678 7.844 1.078 7.034t-.84-1.477A4 4 0 0 1 0 4.202q0-1.363.907-2.283T3.157 1q.828 0 1.564.392.736.393 1.279 1.125a3.8 3.8 0 0 1 1.279-1.125A3.3 3.3 0 0 1 8.842 1q1.345 0 2.251.92.907.918.907 2.282 0 .687-.239 1.355-.238.667-.839 1.477-.6.81-1.625 1.848-1.023 1.038-2.6 2.483zm0-1.298a70 70 0 0 0 2.495-2.37q.978-.989 1.547-1.717t.79-1.294q.22-.565.22-1.119 0-.96-.63-1.601-.633-.64-1.58-.64-.749 0-1.383.43-.635.43-1.005 1.198h-.908q-.377-.774-1.008-1.201a2.4 2.4 0 0 0-1.38-.427q-.942 0-1.576.64T.947 4.202q0 .555.221 1.12.222.565.79 1.293.569.729 1.547 1.713A76 76 0 0 0 6 10.702"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE1F26",
    d: "m5 6.5 1-2 1 2-1 2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "longevity_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgLongevity;